import {
  PROJECTINPUTS_SET,
  PROJECTINPUT_ADDED,
  PROJECTINPUT_EDITED,
  PROJECTINPUT_DELETED,
} from 'src/app/redux/redux-types';
import { reduxProjectInputTypes } from 'src/types';

export const projectInputDefaultState: reduxProjectInputTypes.StateType = {
  projectInputList: [],
};

export const projectInputReducer = (
  state = projectInputDefaultState,
  action: reduxProjectInputTypes.ActionType,
): reduxProjectInputTypes.StateType => {
  switch (action.type) {
    case PROJECTINPUTS_SET:
      return {
        ...state,
        projectInputList: action.payload,
      };
    case PROJECTINPUT_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.projectInputList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        projectInputList: [action.payload, ...state.projectInputList],
      };
    case PROJECTINPUT_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.projectInputList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        projectInputList: [
          ...state.projectInputList.slice(0, updateIndex),
          action.payload,
          ...state.projectInputList.slice(updateIndex + 1),
        ],
      };
    case PROJECTINPUT_DELETED:
      return {
        ...state,
        projectInputList: state.projectInputList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
